import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/media/icons/duotone/Text/Filter.svg'
import _imports_1 from '@/assets/media/icons/duotone/Design/Edit.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-a196c9c8")

_pushScopeId("data-v-a196c9c8")
const _hoisted_1 = { class: "fs-2" }
const _hoisted_2 = { class: "fs text-gray-600" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light btn-active-primary fw-bolder",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_7 = { class: "svg-icon svg-icon-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_FilterChannel = _resolveComponent("FilterChannel")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_table = _resolveComponent("el-table")
  const _component_pagination = _resolveComponent("pagination")
  const _component_table_skeleton = _resolveComponent("table-skeleton")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_el_card, null, {
      default: _withId(() => [
        _createVNode(_component_el_row, { class: "d-flex align-items-center mb-8" }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("channel.title")), 1),
                _createVNode(_component_el_row, { class: "d-flex justify-content-between" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("channel.subtitle")), 1),
                    _createVNode("div", _hoisted_3, [
                      _createVNode("a", _hoisted_4, [
                        _createVNode("span", _hoisted_5, [
                          _createVNode(_component_inline_svg, { src: _imports_0 })
                        ]),
                        _hoisted_6
                      ]),
                      _createVNode(_component_FilterChannel, { onFiltered: _ctx.filtered }, null, 8, ["onFiltered"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_table_skeleton, {
                  loading: !_ctx.data || _ctx.isValidating
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_table, {
                      class: "Channel-table mt-8 fs-7",
                      data: _ctx.data?.data,
                      style: {"width":"100%"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "code",
                          label: "Code"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.code), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          prop: "name",
                          label: "Name"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          prop: "channel",
                          label: "Channel"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.channel), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          align: "right",
                          prop: "action",
                          label: "Action"
                        }, {
                          default: _withId((scope) => [
                            (_ctx.checkPermission('channel-update').isGranted)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: `/app/channel/${scope.row.id}/edit`,
                                  custom: ""
                                }, {
                                  default: _withId(({ href, navigate }) => [
                                    _createVNode(_component_el_tooltip, {
                                      class: "box-item",
                                      effect: "dark",
                                      content: "Edit Channel",
                                      placement: "left"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("a", {
                                          class: "btn btn-sm btn-icon btn-warning mt-2",
                                          href: href,
                                          onClick: navigate
                                        }, [
                                          _createVNode("span", _hoisted_7, [
                                            _createVNode(_component_inline_svg, { src: _imports_1 })
                                          ])
                                        ], 8, ["href", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    (_ctx.data && _ctx.data.current_page)
                      ? (_openBlock(), _createBlock(_component_pagination, {
                          key: 0,
                          onChange: _ctx.handleChangePage,
                          ref: "paginationRef",
                          class: "mt-8",
                          "hide-when-only-one-page": true,
                          page: _ctx.data.current_page,
                          "per-page": _ctx.data.per_page ?? 0,
                          "total-current-page-item": _ctx.data.data.length,
                          "total-all-items": _ctx.data.total ?? 0
                        }, null, 8, ["onChange", "page", "per-page", "total-current-page-item", "total-all-items"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})